import { render } from "./TicketDescription.vue?vue&type=template&id=166c2685&ts=true"
import script from "./TicketDescription.vue?vue&type=script&lang=ts"
export * from "./TicketDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__